import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

import CloseIcon from "../../assets/images/close.png";

import { addIncident, getRisk, closeOverlay, getLevels } from "../../store/actions/riskActions";
import { saveIncident, deleteIncident } from "../../store/actions/incidentActions";
import { connect } from "react-redux";
import { compose } from "redux";


import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';


import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver"; // For saving the generated file


const exportToWord = (data, incident_id, meta = {}) => {
    const documentHeading = meta.documentHeading ?? "Incident Report";
    const fileBase = meta.fileBase ?? "Incident Report";
    // Create a new Document
    const doc = new Document({
        sections: [
            {
                children: [
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: `${documentHeading} | ${incident_id}`,
                                bold: true,
                                size: 24,
                            }),
                        ],
                        spacing: {
                            after: 200, // Add spacing after the paragraph
                        },
                    }),
                    ...data.map((item) =>
                        new Paragraph({
                            children: [new TextRun(item.name + ": " + item.value)],
                            spacing: {
                                after: 200, // Add spacing after each paragraph
                            },
                        })
                    ),
                ],
            },
        ],
    });

    // Generate the document and trigger a download
    Packer.toBlob(doc).then((blob) => {
        saveAs(blob, `${fileBase} | ${incident_id}.docx`);
    });
};



const IMPACT_CARD_LABEL_KEYS = {
    financial: "impactFinancial",
    operational: "impactOperational",
    reputational: "impactReputational",
};

const IncidentOverlay = ({ deleteIncidentFN, saveIncidentFN, risk_id, closeIncident, addIncidentFN, currentIncident, not_editable, risk, getRiskFN, levels, getLevelsFN, is_new }) => {
    const { t } = useTranslation();

    //////console.log("Incident Overlay RIsk:" ,risk)

    const [formState, setFormState] = useState({
        incident_description: currentIncident ? currentIncident.description : '',
        incident_risk: '',
        incident_status: currentIncident ? currentIncident.status : 'Open',
        incident_root_cause: currentIncident ? currentIncident.root_cause : '',
        incident_impact: currentIncident ? currentIncident.impact : '',
        incident_corrective_action: currentIncident ? currentIncident.corrective_action : '',
        incident_preventive_measures: currentIncident ? currentIncident.preventive_measures : ''
    });

    const [showCloseWarning, setShowCloseWarning] = useState(false);
    const [editable, setEditable] = useState(true)
    const [selectedImpact, setSelectedImpact] = useState({
        financial: '',
        operational: '',
        reputational: '',
    })
    const [riks_id, set_risk_id] = useState(true)

    useEffect(() => {
        //////console.log("not_editable ", not_editable)
        if (not_editable) {
            setEditable(!not_editable)

        }
    }, [not_editable]);

    // useEffect(() => {
    //     //////console.log("not_editable ", not_editable)
    //       if (risk) {
    //         ////console.log(risk)

    //     }
    // }, [risk]);

    useEffect(() => {
        //////console.log("not_editable ", not_editable)
        if (risk && levels) {
            const matchedFinancial = levels.riskImpacts.find(
                (item) => item.impact === risk.financial_residual
            );
            setSelectedImpact(prev => ({
                ...prev,
                financial: matchedFinancial
                    ? `$ ${matchedFinancial.financial_low} - ${matchedFinancial.financial_high}`
                    : '',
                operational: levels.riskImpacts.find(
                    (item) => item.impact === risk.operational_residual
                )?.operational || '',
                reputational: levels.riskImpacts.find(
                    (item) => item.impact === risk.reputational_residual
                )?.reputational || '',
            }));

            //////console.log(selectedImpact)
        }
    }, [risk, levels]);

    useEffect(() => {
        getLevelsFN();
    }, [getLevelsFN]);

    useEffect(() => {
        //////console.log("new Incident risk", risk)
        if (is_new === true) {
            setFormState(prev => ({
                ...prev,
                incident_risk: risk.Title,
            }
            ));

        }

    }, [risk]);

    useEffect(() => {
        //////console.log("not_editable ", not_editable)
        if (currentIncident) {
            //set_risk_id(currentIncident.risk_id)
            setFormState(prev => ({
                ...prev,
                incident_description: currentIncident ? currentIncident.description : '',
                incident_risk: currentIncident.title,
                incident_status: currentIncident ? currentIncident.status : '',
                incident_root_cause: currentIncident ? currentIncident.root_cause : '',
                incident_impact: currentIncident ? currentIncident.impact : '',
                incident_corrective_action: currentIncident ? currentIncident.corrective_action : '',
                incident_preventive_measures: currentIncident ? currentIncident.preventive_measures : ''
            }
            ));
            getRiskFN(currentIncident.risk_id)
            ////console.log("Status: ", currentIncident.status)
        }
    }, [currentIncident]);


    const handleChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        NotificationManager.info(t("incidentReport.notificationSubmitted"), "Info", 3000);

        //////////console.log(formState);
        addIncidentFN(risk_id, formState);
        closeIncident();

    };

    const handleSave = (e) => {
        e.preventDefault();

        saveIncidentFN(currentIncident.incident_id, formState);
        closeIncident();

    };

    const handleDelete = () => {

        deleteIncidentFN(currentIncident.incident_id);
        closeIncident();

    };

    const handleStatusChange = (e) => {
        const { value } = e.target;

        if (value === 'Closed') {
            // Instead of immediately setting Closed, show warning
            setShowCloseWarning(true);
        } else {
            setFormState((prev) => ({
                ...prev,
                incident_status: value,
            }));
        }
    };


    const inputStyle = {
        border: "none",
        backgroundColor: "#EEF0ED",
        padding: "12px",
        outline: "none",
        transition: "box-shadow 0.15s ease",
        boxShadow: "inset 0 0 0 0 #3b3b3b",
        borderRadius: "6px",
        resize: "vertical",
    };

    const handleFocus = (e) => {
        e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b";
    };

    const handleBlur = (e) => {
        e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b";
    };

    return (
        <div className="p-6 bg-white rounded-lg">
            <form onSubmit={handleSubmit}>

                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-xl font-semibold text-[#3b3b3b]">{t("incidentReport.title")}</h1>
                    <img
                        src={CloseIcon}
                        alt={t("incidentReport.closeAlt")}
                        className="w-8 h-8 cursor-pointer"
                        onClick={() => closeIncident()}
                    />
                </div>

                {/* Description */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.description")}</label>
                    </div>

                    <textarea
                        name="incident_description"
                        value={formState.incident_description}
                        onChange={handleChange}
                        placeholder={t("incidentReport.placeholders.description")}
                        className="w-full text-sm bg-[#EEF0ED] text-black"
                        style={inputStyle}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                {/* Related Risk */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.relatedRisk")}</label>
                    </div>

                    <textarea
                        name="incident_risk"
                        value={formState.incident_risk}
                        onChange={handleChange}
                        placeholder={t("incidentReport.placeholders.relatedRisk")}
                        className="w-full text-sm bg-[#EEF0ED] text-black"
                        style={inputStyle}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        readOnly
                    />
                </div>

                {/* Impact Summary */}
                {selectedImpact && (
                    <div className="mt-6 py-4">

                        {/* Section Header */}
                        <div className="flex justify-between items-center mb-2">
                            <label className="text-[#3b3b3b] text-sm mb-1">{t("incidentReport.impactSummary")}</label>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {["financial", "operational", "reputational"].map((key) => (
                                <div
                                    key={key}
                                    className="p-4 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition"
                                >
                                    {/* Card header */}
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="text-sm text-[#3b3b3b] mb-1">
                                            {t(`incidentReport.${IMPACT_CARD_LABEL_KEYS[key]}`)}
                                        </label>
                                    </div>

                                    {/* Card content */}
                                    <p className="text-base font-medium text-[#3b3b3b]">
                                        {selectedImpact[key] || t("incidentManagement.notAvailable")}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}


                {/* Root Cause */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.rootCause")}</label>
                    </div>

                    <textarea
                        name="incident_root_cause"
                        value={formState.incident_root_cause}
                        onChange={handleChange}
                        placeholder={t("incidentReport.placeholders.rootCause")}
                        className="w-full text-sm bg-[#EEF0ED] text-black"
                        style={inputStyle}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                {/* Impact */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.impact")}</label>
                    </div>
                    <textarea
                        name="incident_impact"
                        value={formState.incident_impact}
                        onChange={handleChange}
                        placeholder={t("incidentReport.placeholders.impact")}
                        className="w-full text-sm bg-[#EEF0ED] text-black"
                        style={inputStyle}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                {/* Corrective Action */}
                <div className="mb-6">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.correctiveAction")}</label>
                    </div>

                    <textarea
                        name="incident_corrective_action"
                        value={formState.incident_corrective_action}
                        onChange={handleChange}
                        placeholder={t("incidentReport.placeholders.correctiveAction")}
                        className="w-full text-sm bg-[#EEF0ED] text-black"
                        style={inputStyle}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                {/* Preventive Measures */}
                <div className="mb-6">

                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.preventiveMeasures")}</label>
                    </div>
                    <textarea
                        name="incident_preventive_measures"
                        value={formState.incident_preventive_measures}
                        onChange={handleChange}
                        placeholder={t("incidentReport.placeholders.preventiveMeasures")}
                        className="w-full text-sm bg-[#EEF0ED] text-black"
                        style={inputStyle}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                {/* Status */}
                {is_new !== true && (
                    <div className="mb-6">
                        {is_new !== true && (
                            <div className="flex justify-between items-center mb-1">
                                <label className="text-[#3b3b3b] mb-1 text-sm">{t("incidentReport.status")}</label>
                            </div>
                        )}
                        <select
                            name="incident_status"
                            value={formState.incident_status}
                            onChange={handleStatusChange}
                            className="w-full text-sm bg-[#EEF0ED] text-black p-3 rounded"
                            disabled={formState.incident_status === "Closed"}
                            style={{
                                border: "none",
                                outline: "none",
                                boxShadow: "inset 0 0 0 0 #3b3b3b",
                                transition: "box-shadow 0.15s",
                            }}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            required
                        >
                            <option value="Open">{t("incidentReport.statusOpen")}</option>
                            <option value="In Progress">{t("incidentReport.statusInProgress")}</option>
                            <option value="Closed">{t("incidentReport.statusClosed")}</option>
                        </select>
                    </div>
                )}

                {/* Close Warning */}
                {showCloseWarning && (
                    <div className="mt-4 p-4 border border-red-500 bg-red-100 rounded">
                        <p className="text-red-700 font-semibold mb-2">
                            {t("incidentReport.closeWarning")}
                        </p>
                        <div className="flex gap-2">
                            <button
                                onClick={() => {
                                    setFormState((prev) => ({
                                        ...prev,
                                        incident_status: "Closed",
                                    }));
                                    saveIncidentFN(currentIncident.incident_id, {
                                        ...formState,
                                        incident_status: "Closed",
                                    });
                                    setShowCloseWarning(false);
                                }}
                                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                            >
                                {t("incidentReport.yes")}
                            </button>
                            <button
                                onClick={() => setShowCloseWarning(false)}
                                className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 transition"
                            >
                                {t("incidentReport.cancel")}
                            </button>
                        </div>
                    </div>
                )}

                {/* Action Buttons */}
                {(is_new === true && formState.incident_status === "Open") && (
                    <button type="submit" className="bg-[#3b3b3b] text-white py-2 px-4 rounded">
                        {t("incidentReport.submit")}
                    </button>
                )}

                {(is_new !== true && formState.incident_status === "Open") && (
                    <button onClick={handleSave} className="bg-[#3b3b3b] text-white py-2 px-4 rounded">
                        {t("incidentReport.saveAndQuit")}
                    </button>
                )}

                {formState.incident_status !== "Open" && (
                    <div className="flex gap-3">
                        <button
                            type="button"
                            className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70"
                            onClick={() =>
                                exportToWord(
                                    [
                                        { name: t("incidentReport.wordFields.description"), value: formState.incident_description },
                                        { name: t("incidentReport.wordFields.rootCause"), value: formState.incident_root_cause },
                                        { name: t("incidentReport.wordFields.impact"), value: formState.incident_impact },
                                        { name: t("incidentReport.wordFields.correctiveAction"), value: formState.incident_corrective_action },
                                        { name: t("incidentReport.wordFields.preventiveMeasures"), value: formState.incident_preventive_measures },
                                    ],
                                    currentIncident.incident_id,
                                    {
                                        documentHeading: t("incidentReport.title"),
                                        fileBase: t("incidentReport.title"),
                                    }
                                )
                            }
                        >
                            {t("incidentReport.exportToWord")}
                        </button>

                        {formState.incident_status === "Closed" && (
                            <button
                                type="button"
                                className="bg-red-600 text-white py-2 px-4 rounded hover:bg-red-700"
                                onClick={() => handleDelete()}
                            >
                                {t("incidentReport.deleteIncident")}
                            </button>
                        )}
                    </div>
                )}
            </form>
        </div>
    );

};

const mapStateToProps = (state) => {
    ////console.log("currentIncident", state.incident.incident)
    return {

        risk: state.risk.risk ? state.risk.risk.risk : null,
        currentIncident: state.incident.incident,
        levels: state.risk.levels,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addIncidentFN: (risk_id, incident) => dispatch(addIncident(risk_id, incident)),
        saveIncidentFN: (incident_id, incident) => dispatch(saveIncident(incident_id, incident)),
        deleteIncidentFN: (incident_id) => dispatch(deleteIncident(incident_id)),
        getRiskFN: (risk_id) => dispatch(getRisk(risk_id)),
        closeOverlayFN: () => dispatch(closeOverlay()),
        getLevelsFN: () => dispatch(getLevels()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(IncidentOverlay);